import React from 'react';
import { Tag } from '@zillow/constellation-10';

export type ZimEligibilityStatus = 'eligible' | 'not-eligible' | 'connected';

export interface ZimEligibilityTagProps {
  status: ZimEligibilityStatus;
}

const ZIM_STATUS_CONFIG: Record<ZimEligibilityStatus, { tone: 'blue' | 'critical' | 'success'; label: string }> = {
  eligible: { tone: 'blue', label: 'ZIM eligible' },
  'not-eligible': { tone: 'critical', label: 'Not ZIM eligible' },
  connected: { tone: 'success', label: 'ZIM connected' },
};

export const ZimEligibilityTag: React.FC<ZimEligibilityTagProps> = ({ status }) => {
  const config = ZIM_STATUS_CONFIG[status];

  return (
    <Tag size="sm" tone={config.tone} css={{ alignSelf: 'flex-start' }}>
      {config.label}
    </Tag>
  );
};
